import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { getYear } from 'date-fns';
import { DateInputFormat, DayMonthHeader } from "../../DateComponents";
import { Actions as PAYSCHEDULEACTIONS } from '../../../../store/actions/payScheduleActions';

const payFrequencyOptions = [
  { label: 'every week', payFrequency: 52, value: 'every week' },
  { label: 'every 2 weeks', payFrequency: 26, value: 'every 2 weeks' },
  { label: 'every 4 weeks', payFrequency: 13, value: 'every 4 weeks' },
  { label: 'every month', payFrequency: 12, value: 'every month' },
  { label: '4-4-5 weeks', payFrequency: 12, value: '4-4-5', },
];

const payDeadlineOptions = [
  { label: 'days before payday', value: 'days' },
  { label: 'of the month', value: 'of the month' },
];

const payDayOptions = [
  { label: 'day of the month', value: 'of the month' },
  { label: 'of the period', value: 'of the period' },
  { label: 'days after end of period', value: 'days' },
  { label: 'working days after end of period', value: 'workingdays' },
];

const payDayDurationOptions = [
  { label: 'last Monday', value: 'last Monday' },
  { label: 'last Tuesday', value: 'last Tuesday' },
  { label: 'last Wednesday', value: 'last Wednesday' },
  { label: 'last Thursday', value: 'last Thursday' },
  { label: 'last Friday', value: 'last Friday' },
  { label: 'last day', value: 'last day' },
];

const PayScheduleRow = ({ paySchedule, updateSetting, inModal, payDayType, payDeadlineType, payFrequency, jurisdiction, disabled }) => {
  return (
    <div className="col-xs-12 pl-0 pr-0 form-inner-box" style={{ paddingTop: '2rem'}}>
      <div className="col-xs-4">
        <div className="form-material">
          <input
            style={{ maxWidth: "100%" }}
            name="name"
            value={paySchedule?.name}
            className='form-control form-input'
            disabled={disabled}
            required
            onChange={(e) => updateSetting(paySchedule?.id, e.target.name, e.target.value)}
            defaultValue={paySchedule?.name}
          />
          <label>Name</label>
          <div className="clearfix" />
        </div>
      </div>
      <div className="col-xs-4">
        <div className="form-material">
          <Select
            options={payFrequencyOptions}
            style={{ width: '100px' }}
            valueName="selected"
            isDisabled={disabled}
            value={payFrequencyOptions.find((option) => paySchedule?.type ? paySchedule?.type == option.value : option.payFrequency == paySchedule?.payFrequency)}
            defaultValue={payFrequencyOptions.find((option) => option.label === 'every month')}
            onChange={(e) => {
              updateSetting(paySchedule?.id, "payFrequency", e.payFrequency)
              updateSetting(paySchedule?.id, "type", e.value)
              if (e.value !== 12) {
                if (!payDayType || payDayType === "of the month"){
                  updateSetting(paySchedule?.id, "payDay", payDayOptions.filter(p => p.value !== "of the month")?.[0].value, "type")
                  updateSetting(paySchedule?.id, "payDay", payDayDurationOptions.find(p => p.value == "last Friday").value, "value")}
                if (!payDeadlineType || payDeadlineType === "of the month") updateSetting(paySchedule?.id, "deadline", payDeadlineOptions[0].value, "type")
              }
            }}
          />
          <label>Pay Frequency</label>
          <div className="clearfix" />
        </div>
        <div className="clearfix" />
      </div>
      <div className="col-xs-4">
        <div className="form-material">
          <input
            type="number"
            className='form-control form-input'
            max="31"
            min="1"
            style={{
              width: 'calc(25% - 5px)',
              display: 'inline-block',
            }}
            disabled={disabled}
            name="deadline"
            value={paySchedule?.deadline?.value}
            required
            onChange={(e) => updateSetting(paySchedule?.id, e.target.name, e.target.value, "value")}
            defaultValue={paySchedule?.deadline?.value}
          />
          <div
            style={{
              width: 'calc(75% - 5px)',
              display: 'inline-block',
              marginLeft: '5px',
            }}
          >
            <Select
              options={payFrequency == 12 ? payDeadlineOptions : payDeadlineOptions.filter(p => p.value != "of the month")}
              valueName="selected"
              placeholder="Choose one"
              isDisabled={disabled}
              value={payDeadlineOptions.find(payDeadline => payDeadline.value == paySchedule?.deadline?.type)}
              onChange={(e) => updateSetting(paySchedule?.id, "deadline", e.value, "type")}
            />
          </div>
          <label>Payroll Deadline</label>
          <div className="clearfix" />
        </div>
      </div>
      <div className="col-xs-12 pr-0 pl-0">
        { jurisdiction.countryCode != "MT" ? (
          <div className="col-xs-2 pl-0 form-material pull-right">
            <label>Cycle Start Date</label>
            <DatePicker
              selected={paySchedule?.cycleStart && new Date(paySchedule?.cycleStart)}
              onChange={(date) => updateSetting(paySchedule?.id, 'cycleStart', date)}
              showMonthDropdown
              minDate={new Date(getYear(new Date()), 0, 1)}
              maxDate={new Date(getYear(new Date()), 11, 31)}
              dateFormat="do MMMM"

              showDisabledMonthNavigation
              renderCustomHeader={({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => <DayMonthHeader date={date} decreaseMonth={decreaseMonth} increaseMonth={increaseMonth} prevMonthButtonDisabled={prevMonthButtonDisabled} nextMonthButtonDisabled={nextMonthButtonDisabled} />}
              customInput={<DateInputFormat />}
            />
          </div>
        ) : <div className="col-xs-2 pl-0 form-material pull-right"/>}
        <div className='col-xs-6 form-material pr-0 pull-right'>
          <label style={{ paddingLeft: '1.5rem'}}>Payday</label>
          <div className='col-xs-6 pl-0 form-material' style={{ marginTop: 0}}>
            {['of the period'].includes(paySchedule?.payDay?.type) ?
              <Select
                options={payDayDurationOptions}
                valueName="selected"
                placeholder="Choose one"
                required
                isDisabled={disabled}
                value={payDayDurationOptions.find((pdDuration) => pdDuration.value == paySchedule?.payDay?.value)}
                onChange={(e) => updateSetting(paySchedule?.id, "payDay", e.value, "value")}
              />
              :
              <input
                type="number"
                max="31"
                min="1"
                name="payDay"
                className='form-control form-input'
                disabled={disabled}
                value={paySchedule?.payDay?.value}
                onChange={(e) => updateSetting(paySchedule?.id, e.target.name, e.target.value, "value")}
                required="required"
                aria-required="true"
              />
            }
          </div>
          <div className='col-xs-6 pl-0'>
            <Select
              options={payFrequency == 12 ? payDayOptions : payDayOptions.filter(p => p.value != "of the month")}
              valueName="selected"
              placeholder="Choose one"
              isDisabled={disabled}
              value={payDayOptions.find((pd) => pd.value == paySchedule?.payDay?.type)}
              onChange={(e) => {
                updateSetting(paySchedule?.id, "payDay", e.value, "type")
                updateSetting(paySchedule?.id, "payDay", "last day", "value")
              }}
            />
          </div>
        </div>
        <div className="clearfix" />
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    payFrequency: ownProps.paySchedule?.payFrequency,
    payDeadlineType: ownProps?.paySchedule?.deadline?.type,
    payDayType: ownProps?.paySchedule?.payDay?.type,
    jurisdiction: state.jurisdiction,
  }
};

const mapDispatchToProps = (dispatch) => ({
  updateSetting: (id, field, newValue, fieldType) => dispatch(PAYSCHEDULEACTIONS.updateSetting(id, field, newValue, true, fieldType))
});

export default connect(mapStateToProps, mapDispatchToProps)(PayScheduleRow);